
<div>
  <div *ngIf="true" class="card" style="width: 100%;">
    <div class="card-body">
      <h6 class="card-subtitle mb-2 text-muted">
        Please review your payment details
      </h6>
      <p class="card-text"></p>
      <ul>
        <li>
          <p *ngIf="showACHPaymentOption && showCreditCardPaymentOption" style="margin:0px;">
            All Invoices available for payment are shown below.  Use the checkboxes to select the invoices to be paid.  Once all invoices are selected, click the <b>"Proceed to ACH Payment"</b> or <b>"Proceed to Credit Card Payment"</b> to complete the payment process.
          </p>
          <p *ngIf="showACHPaymentOption && !showCreditCardPaymentOption" style="margin:0px;">
            All Invoices available for payment are shown below.  Use the checkboxes to select the invoices to be paid.  Once all invoices are selected, click the <b>"Proceed to ACH Payment"</b> to complete the payment process.
          </p>
          <p *ngIf="!showACHPaymentOption && showCreditCardPaymentOption" style="margin:0px;">
            All Invoices available for payment are shown below.  Use the checkboxes to select the invoices to be paid.  Once all invoices are selected, click the <b>"Proceed to Credit Card Payment"</b> to complete the payment process.
          </p>
        </li>
        <li *ngIf="showACHPaymentOption">
          ACH Payments made after 8pm EST will not be processed until the following business day.
        </li>
        <li *ngIf="showCreditCardPaymentOption">
          Credit Card Payments made after 9:30pm EST will not be processed until the following business day.
        </li>
        <li>
          Open Invoices/Credits older than 1 year will not be displayed.  Please reach out to your Credit Manager to discuss options.
        </li>
        <li>
          Future Dated payments may cause credit holds or voided discounts if the date selected is beyond the due date.
        </li>
        <li>
          Web browsers that are not kept current may experience odd behavior.  For best results, ensure your browser is updated to the latest version.
        </li>
      </ul>
    </div>
  </div>
</div>
<div>
  <!--[group]="groups"-->
  <kendo-grid [data]="paymentReviewGridData"
              class="invoiceInquiryGridCls"
              [navigable]="true"
              [groupable]="false"
              [resizable]="true"
              [height]="500"
              [loading]="paymentGridLoading"
              [sortable]="true"
              [sort]="paymentReviewGridState.sort"
              [filterable]="true"
              [filter]="paymentReviewGridState.filter"
              (dataStateChange)="paymentReviewGridDataStateChange($event)">
    <!--(cellClick)="cellClickHandler($event)"
    (cellClose)="cellCloseHandler($event)"
    (remove)="removeHandler($event)">-->
    <!--GRID FOR PWA (LESS THAN 1024PX) START-->
    <!--GRID FOR PWA (LESS THAN 1024PX) END-->

    <kendo-grid-column [width]="45">
      <ng-template kendoGridHeaderTemplate let-dataItem>
        <input type="checkbox" style="width:20px;height:20px;"
               (change)="selectAllInvoiceForPayment($event)" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <input type="checkbox" style="width:20px;height:20px;"
               [checked]="dataItem.selectedForPayment"
               (change)="selectInvoiceForPayment($event,dataItem)" />
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column *ngFor="let col of paymentReviewGridSettings.columnsConfig"
                       [field]="col.field"
                       [title]="col.title"
                       [filter]="col.filter"
                       [filterable]="col.filterable"
                       [hidden]="col.hidden"
                       [format]="col.format"
                       [width]="col._width"
                       media="(min-width: 1025px)">
      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'invoiceNumber'">
        {{ dataItem.invoiceNumber }}
      </ng-template>
      <ng-template kendoGridFilterCellTemplate
                   let-filter
                   let-column="column"
                   *ngIf="col.field == 'invoiceDateAsDate'">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="invoiceDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column" *ngIf="col.field == 'dueDateAsDate'">
        <app-grid-daterange-filter class="date-range-filter"
                                   [filter]="filter"
                                   field="dueDateAsDate">
        </app-grid-daterange-filter>
      </ng-template>
      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'originalAmount'">
        {{ dataItem?.originalAmount | currency }}
      </ng-template>
      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'amountDue'">
        {{ dataItem?.amountDue | currency }}
      </ng-template>
      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'payAmount'">
        <div *ngIf="dataItem.selectedForPayment">
          <div *ngIf="dataItem.type == 'RM'">
            {{ dataItem?.payAmount | currency }}
          </div>
          <div *ngIf="dataItem.type !== 'RM' && dataItem.amountDue>0">
            <kendo-numerictextbox [value]="dataItem.payAmount"
                                  [spinners]="false" [format]="'c2'" [decimals]="2"
                                  [min]="0"
                                  [style.width.px]="90"
                                  (valueChange)="handlePaymentAmountChange($event,dataItem)"
                                  [autoCorrect]="true" class="qtyTxtCls">
            </kendo-numerictextbox>
          </div>
        </div>
      </ng-template>

      <ng-template kendoGridFooterTemplate
                   *ngIf="col.field == 'payAmount'">
        <div title="Total AmountDue">
          <div>
            <strong>Total: {{toatlAmt | currency}}</strong>
          </div>
        </div>
      </ng-template>

      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'paymentReason'">
        <div *ngIf="dataItem.selectedForPayment && dataItem.type !== 'RM' && dataItem.amountDue>0">
          <div *ngIf="dataItem.paymentReasonRequired">
            <kendo-textarea [style.width.%]="90"
                            (valueChange)="handlePaymentReasonEntered($event,dataItem)"
                            [maxlength]="maxReasonLength"
                            [value]="dataItem.paymentReason"
                            placeholder="Please enter reason">
              <kendo-textarea-suffix class="payment-reason-char-counter">
                <span class="counter">{{ dataItem.paymentReasonCharCounter }}</span>
              </kendo-textarea-suffix>
            </kendo-textarea>
          </div>
        </div>
      </ng-template>

      <ng-template kendoGridFooterTemplate
                   *ngIf="col.field == 'paymentReason'">
        <div *ngIf="totalInvoiceSelected>0">
          <div>
            <strong>Total Lines Selected : {{totalInvoiceSelected}}</strong>
          </div>
        </div>
      </ng-template>

      <ng-template kendoGridCellTemplate
                   let-filter
                   let-column="column"
                   let-dataItem
                   *ngIf="col.field == 'paymentComments'">
        <div *ngIf="dataItem.selectedForPayment && dataItem.type !== 'RM'">
          <ul>
            <li *ngFor="let c of dataItem.paymentComments">
              <span *ngIf="!c.isError" style="color:green">{{c.message}}</span>
              <span *ngIf="c.isError" style="color:red">{{c.message}}</span>
            </li>
          </ul>
        </div>

      </ng-template>
    </kendo-grid-column>

    <ng-template kendoGridNoRecordsTemplate> </ng-template>
  </kendo-grid>

</div>
<div class="d-super-center flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row" style="text-align: center" *ngIf="!monthlyFreezeActive">
  <!--<button kendoButton
          (click)="goBack()"
          class="m-3 clearKendoButton btn backButton" style="margin: 0 auto;">
    Cancel
  </button>-->
  <button kendoButton
          (click)="proceedToACHPaymentGateway()" *ngIf="showACHPaymentOption"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Proceed to ACH Payment
    <kendo-loader *ngIf="paymentInProgress"></kendo-loader>
  </button><br />
  <button kendoButton
          (click)="beginCCPayment()" *ngIf="showCreditCardPaymentOption"
          class="m-3 clearKendoButton btn btn-success" style="margin: 0 auto;">
    Proceed to Credit Card Payment
    <kendo-loader *ngIf="ccPaymentInProgress"></kendo-loader>
  </button><br />
  <b *ngIf="ccPaymentInProgress">Please wait, you are being redirected to payment portal...</b>
</div>
<kendo-dialog title="Payment Received" *ngIf="showCashModal" (close)="closeCashPayModal()">
  <p style="margin: 30px; text-align: center;">
    Payment received.  Please allow 1-2 business days to process.
  </p>
  <kendo-dialog-actions>
    <button class='k-button' (click)="closeCashPayModal(true)">
      OK
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Proceed to Credit Card Payment?" *ngIf="showSurchargeDialog"
              (close)="closeSurchargeConfirmationBox()">
  <p style="margin: 30px; text-align: center;">
    A surcharge of 3% will be applied to all Credit Card transactions (exclusions per states laws may be applicable). <br />
    There is no surcharge on ACH payments. <br />
    Would you like to proceed to pay via Credit Card?
  </p>
  <kendo-dialog-actions (layout)="actionsLayout">
    <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <button class='k-button' (click)="closeSurchargeConfirmationBox()">
        No
      </button>
      <!--Have a spinner-->
      <button class='k-button k-primary' style="margin-left:10px;"
              (click)="proceedToCreditCardPaymentGateway()" primary="true">
        Yes
      </button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog title="Credit Card Transaction Limit Reached" *ngIf="showCCTranLimitModal"
              (close)="closeCCTranLimitModal()">
  <p style="margin: 30px; text-align: center;">
    Credit Card transactions are limited to a maximum of {{ccTranMaxLimit | currency}}<br />
    Please reduce the Total Transaction Amount by deselecting some invoices and try again.<br />
    You can submit Multiple transactions if needed.
  </p>
  <kendo-dialog-actions (layout)="actionsLayout">
    <div style="width: 100%; display: flex; justify-content: center; align-items: center;">
      <button class='k-button' (click)="closeCCTranLimitModal()">
        Ok
      </button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
